export default {"src":"/_next/static/media/klarna.a8c23fa8.svg","height":25,"width":45,"blurWidth":0,"blurHeight":0};